{
  "name": "demo",
  "version": "0.12.5",
  "scripts": {
    "test": "echo \"Error: no test specified\" && exit 1",
    "d": "parcel src/index.html --https --host 0.0.0.0",
    "build": "parcel build src/index.js --dist-dir build",
    "b": "yarn remove-zip & yarn build && yarn zip",
    "remove-zip": "rm *.zip",
    "zip": "zip -r build.zip build && rm -r build",
    "build:prod": "parcel build src/index.html --dist-dir ./build"
  },
  "browserslist": [
    "last 2 ChromeAndroid versions",
    "last 2 iOS major versions"
  ],
  "keywords": [],
  "author": "HYPERVSN",
  "license": "ISC",
  "description": "",
  "packageManager": "yarn@4.9.2",
  "dependencies": {
    "@emotion/react": "^11.14.0",
    "@rive-app/react-canvas": "^4.28.4",
    "motion": "^12.38.0",
    "react": "^19.2.6",
    "react-dom": "^19.2.6",
    "react-router": "^7.15.0",
    "react-router-dom": "^7.15.0"
  },
  "devDependencies": {
    "@babel/core": "^7.29.0",
    "@emotion/babel-plugin": "^11.13.5",
    "@parcel/reporter-bundle-analyzer": "^2.16.4",
    "@parcel/transformer-svg-jsx": "^2.16.4",
    "parcel": "^2.16.4"
  },
  "alias": {
    "process": false
  }
}
